import React from "react";
import { TicketsSummaryPdfDocument } from "./TicketsSummaryPdfDocument";

export async function openTicketsSummaryPdfReport({ companyInfo, filters, report }) {
  const reportTab = typeof window !== "undefined" ? window.open("", "_blank") : null;
  if (!reportTab) throw new Error("Unable to open report tab. Please allow pop-ups and try again.");

  try {
    const { Document, Page, StyleSheet, Text, View, Image, pdf } = await import("@react-pdf/renderer");
    const generatedAt = new Date().toISOString();
    const logoUrl = typeof window !== "undefined" ? `${window.location.origin}/light.png` : "/light.png";

    const reportBlob = await pdf(
      <TicketsSummaryPdfDocument
        components={{ Document, Page, StyleSheet, Text, View, Image }}
        logoUrl={logoUrl}
        companyInfo={companyInfo}
        filters={filters}
        report={report}
        generatedAt={generatedAt}
      />
    ).toBlob();

    const reportUrl = URL.createObjectURL(reportBlob);
    reportTab.location.href = reportUrl;
    setTimeout(() => URL.revokeObjectURL(reportUrl), 60_000);
  } catch (error) {
    reportTab.close();
    throw error;
  }
}
